<template>
  <div :id="id">
    <b-form-group :label="title">
      <div class="labels fake-form-control">
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center flex-wrap">
            <span class="keyword" v-for="label in labels" :key="label">
              <b-badge variant="secondary">
                {{ label }}
              </b-badge>
            </span>
          </div>
          <div class="edit-labels-button ml-auto">
            <b-button size="" variant="primary" @click.stop="showEditor">
              <font-awesome-icon icon="pen"/>
               <span>Edit</span>
            </b-button>
          </div>
        </div>
      </div>
    </b-form-group>
    <EditLabels :labels="labels" @update="$emit('update', $event)" ref="editLabels" :allow-new="allowNew" :label-type="labelType"/>
  </div>
</template>

<script>
import EditLabels from "./EditLabels.vue"

export default {
  name: 'LabelsInput',

  components: {
    EditLabels
  },

  data() {
    return {}
  },

  props: {
    id: String,
    language: String,
    labels: Array,
    allowNew: {type: Boolean, default: true},
    labelType: {type: String, default: "label"},
    title: {type: String, default: null}
  },

  methods: {
    showEditor() {
      this.$refs.editLabels.show();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


  .keyword {
    margin-right: 4px;
    margin-bottom: 2px;
    display: inline-block;
  }
  
  // Tag styling
  .badge-secondary {
      background-color: rgba(255,255,255,0.1);
      border: 1px solid rgba(255,255,255,0.1);
      color: #E5E9EC;
  }
  
  // Make the button small and fit well
  .edit-labels-button {
      .btn {
          padding: 2px 8px;
          font-size: 0.7rem; 
      }
  }
</style>
